import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, newRef, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";

const CATEGORIES = { out: ["Petty cash", "Supplies", "Bank deposit", "Staff advance", "Lab payment", "Other"], in: ["Opening float", "Cash from bank", "Other income", "Other"] };

export default function CashEntryForm({ day, onClose, onSaved }) {
  const [form, setForm] = useState({ direction: "out", amount: "", category: "Petty cash", description: "" });
  const [clientRef] = useState(newRef);
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const r = await api.post("/cashbook/entries", { ...form, amount: Number(form.amount), date: day, client_ref: clientRef });
    toast.success(`Cash ${form.direction === "out" ? "out" : "in"} entry saved`);
    onSaved(r.data);
  });
  return (
    <Modal eyebrow={`CASHBOOK · ${day}`} title="Add cash entry" onClose={onClose} onSubmit={save} testid="cash-entry-form">
      <Field label="Direction" testid="cash-direction-select" value={form.direction} onChange={(v) => setForm({ ...form, direction: v, category: CATEGORIES[v][0] })} options={[{ value: "out", label: "Cash out of the drawer" }, { value: "in", label: "Cash into the drawer" }]} />
      <div className="form-two">
        <Field label="Amount (₹)" type="number" min="0.01" step="0.01" required testid="cash-amount-input" value={form.amount} onChange={set("amount")} />
        <Field label="Category" testid="cash-category-select" value={form.category} onChange={set("category")} options={CATEGORIES[form.direction]} />
      </div>
      <Field label="Description" required testid="cash-description-input" value={form.description} onChange={set("description")} placeholder="e.g. Gloves and cotton from local store" />
      <p className="muted small-note">Patient payments and refunds in cash are added automatically.</p>
      <ErrorBox error={error} testid="cash-entry-error" />
      <button className="primary full" disabled={busy} data-testid="save-cash-entry-button"><Check size={17} /> {busy ? "Saving…" : "Save entry"}</button>
    </Modal>
  );
}
